(function signNacionDirectiveDefinition() {
    'use strict';

    angular.module('SignNacionControl', [])
        .directive('signNacion', function () {
            return {
                restrict: 'E',
                templateUrl: '/app/directives/sign-nacion/sign-nacion.html',
                scope:
                {
                    processId: '=',
                    callbackUrl: '=',
                    certId: '=',
                    agreement: '=',
                    motive: '='
                },
                controller: [
                    '$scope', '$element', 'fileWorkflowService', '$window', 'errorsExtend', function ($scope, $element, fileWorkflowService, $window, errors) {
                        $scope.signNacion = function () {
                            if ($scope.agreement === 'NC' && $scope.motive === '') {
                                errors.showError('VerifyFormData');
                                return;
                            }

                            fileWorkflowService.SignDocument($scope.processId, $scope.callbackUrl, $scope.certId, $scope.agreement, $scope.motive).then(function (result) {
                                $window.location = result.value;
                            }, function (error) {
                                errors.showError(error);
                            });
                        };

                    }]
            };
        });
})();